import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultLayoutComponent } from './containers';
import { AppAuthGuard } from './guards/auth.guard';
import { AppAuthVerifyGuard } from './guards/authVerify.guard';
import { AppDummyComponent } from './modules/@shared/components/_dummy/_dummy';

export const routes: Routes = [
  {
    path: '_dummy',
    component: AppDummyComponent,
  },
  {
    path: '',
    loadChildren: () => import('./modules/auth/auth.routing').then(m => m.AppAuthRouting),
  },
  {
    path: '',
    loadChildren: () => import('./modules/error-page/error-page.routing').then(m => m.AppErrorPageRouting),
  },
  { // Quì perché possiede un proprio container
    path: 'document',
    loadChildren: () => import('./modules/document/document.routing').then(m => m.AppDocumentRouting)
  },
  { // Quì perché possiede un proprio container
    path: 'rsmap',
    loadChildren: () => import('./modules/rs-map/rs-map.routing').then(m => m.AppRsMapRouting)
  },
  { // Quì perché possiede un proprio container
    path: '',
    loadChildren: () => import('./modules/ptv-tools/ptv-tools-map.routing').then(m => m.AppPtvToolsMapRouting)
  },
  { // Quì perché possiede un proprio container
    path: '',
    loadChildren: () => import('./modules/ptv-tools/ptv-tools-other.routing').then(m => m.AppPtvToolsOtherRouting)
  },
  {
    path: '',
    canActivate: [AppAuthVerifyGuard],
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'home',
        component: AppDummyComponent,
      },
      {
        path: 'dashboard',
        pathMatch: 'full',
        redirectTo: 'rsmap/dashboard',
      },
      {
        path: 'communication',
        loadChildren: () => import('./modules/communication/communication.routing').then(m => m.AppCommunicationRouting),
        canActivate: [AppAuthGuard]
      },
      {
        path: 'crm',
        loadChildren: () => import('./modules/crm/crm.routing').then(m => m.AppCrmRouting),
        canActivate: [AppAuthGuard]
      },
      {
        path: 'planning',
        loadChildren: () => import('./modules/planning/planning.routing').then(m => m.AppPlanningRouting),
        canActivate: [AppAuthGuard]
      },
      {
        path: 'profile',
        loadChildren: () => import('./modules/appmenu/appmenu.routing').then(m => m.AppAppmenuRouting),
        canActivate: [AppAuthGuard]
      },
      {
        path: 'profile',
        loadChildren: () => import('./modules/profile/profile.routing').then(m => m.AppProfileRouting),
        canActivate: [AppAuthGuard]
      },
      {
        path: 'session-manager',
        loadChildren: () => import('./modules/session-manager/session-manager.routing').then(m => m.AppSessionManagerRouting),
        canActivate: [AppAuthGuard]
      },
      {
        path: 'system',
        loadChildren: () => import('./modules/system/system.routing').then(m => m.AppSystemRouting),
        canActivate: [AppAuthGuard]
      },
      {
        path: 'trace',
        loadChildren: () => import('./modules/trace/trace.routing').then(m => m.AppTraceRouting)
      },
      {
        path: 'xserver',
        loadChildren: () => import('./modules/ptv-xserver/xserver.routing').then(m => m.AppXServerRouting)
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRouting { }
